export default {
  zh: {
    ':': '：',
    download: '下载',
    downloadVpn: '下载 ',
    client: '客户端',
    clientInfo: ' 版 Plex加速器保护您的隐私和安全',
    support: '支持系统',
    version: '最新版本',
    winVersion: '版本',
    fileSize: '文件大小',
    requirements: '依赖',
    tryQt: '新功能抢先体验',
    requirementsNotice: '（下载安装前，请先退出杀毒软件）',
    appleId: '苹果账户：',
    applePassword: '密码：',
    appAccountsNotice: '（Plex加速器已从中国区App Store下架，请使用下方账户前往美国区搜“plexvpn”下载。）',
    updateTime: '更新时间',
    apple_account_tips: [
      '注意：（重要！！！）',
      '1. 请在AppStore里面登录美区账号（不要在设置里登录）',
      '2. 下载完Plex加速器以后，请及时退出账号',
      '请务必遵守以上2条，不然手机有被锁的风险！'
    ]
  },
  en: {
    ':': ': ',
    download: 'Download',
    downloadVpn: 'Download PlexVPN for ',
    client: ' ',
    clientInfo: ' to protect your online privacy and security',
    support: 'Support',
    version: 'Latest Version',
    winVersion: ' version',
    fileSize: '	File Size',
    requirements: 'Requirements',
    tryQt: 'New Features Sneak Peek',
    requirementsNotice: '( Please disable the anti-virus software, and then download and install client )',
    appleId: 'Apple ID: ',
    applePassword: 'Password: ',
    appAccountsNotice: '(PlexVPN has been removed from APP Store in China, please login the following US APP Store account and search "plexvpn" to download.)',
    updateTime: 'Update Time',
    apple_account_tips: [
      'Note: (Important !!!)',
      '1. Please log in to the US AppleID in the AppStore (not in the settings).',
      '2. After downloading PlexVPN, please log out it in time.',
      'Please follow the above 2 steps, otherwise your phone could be locked!'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/download/downloadBanner/lang.js